
<template>
  <div>
    <v-dialog v-model="dialog" transition="dialog-bottom-transition" scrollable width="600px">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on" small><v-icon left>mdi-plus</v-icon>Categoria</v-btn>
      </template>
      <v-card v-if="dialog">
        <v-card-title primary-title class="pa-0">
          <v-toolbar dark color="primary" >
            <v-toolbar-title>Nova categoria</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="closeDialog()" dark>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-form ref="createForm">
            <v-text-field label="Nome" v-model="new_category.name" :rules="required"></v-text-field>
            <v-text-field label="Código" v-model="new_category.code" type="number" :rules="required"></v-text-field>
            <v-text-field label="Referência" v-model="new_category.percent_ref" type="number" :rules="required"></v-text-field>
            <v-select label="Tipo" :items="kind_options" v-model="new_category.kind" :rules="required" item-value="value" item-text="name"></v-select>
            <v-textarea label="Descrição" v-model="new_category.description"></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn color="success" @click="newCategory()"><v-icon left>mdi-check</v-icon>Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import validations from '@/mixins/validations';

export default {
  name: 'CreateCategoryDialog',
  mixins: [
    validations
  ],
  data() {
    return {
      dialog: false,
      new_category: {
        name: '',
        code: 0,
        percent_ref: 0,
        kind: null,
        description: ''
      },
      kind_options: [
        {
          name: 'Produtivo',
          value: 'P'
        },
        {
          name: 'Improdutivo',
          value: 'I'
        }
      ]
    }
  },
  methods: {
    closeDialog() {
      this.new_category = {
        name: '',
        code: 0,
        percent_ref: 0,
        kind: null,
        description: ''
      };
      this.dialog = false;
    },
    newCategory() {
      if (this.$refs.createForm.validate()) {
        this.new_category.percent_ref = Number(Number(this.new_category.percent_ref).toFixed(1))
        console.log(this.new_category)
        // this.createCategory(this.new_category).then(() => {
        //   this.new_category = {
        //     name: '',
        //     code: 0,
        //     percent_ref: 0,
        //     kind: null,
        //     description: ''
        //   }
        //   this.dialog = false;
        // })
      }
    },
    ...mapActions({
      createCategory: 'Category/create'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>